import { render, staticRenderFns } from "./CurrentDownloads.vue?vue&type=template&id=19b579b1&"
import script from "./CurrentDownloads.vue?vue&type=script&lang=js&"
export * from "./CurrentDownloads.vue?vue&type=script&lang=js&"
import style0 from "~/assets/scss/sections/download/download-status-lists.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports